import ScanSample from "../../Lab Admin Tabs/ScanSample/ScanSample";


const AnalystScanSample = ({ TabConfig }) => {
  return <ScanSample TabConfig={TabConfig} />;
};

export default AnalystScanSample;